let internetConnectionStatus = null;

let changeNetworkState = (newState) => {
  if ((internetConnectionStatus !== null && internetConnectionStatus !== newState) || newState === 0) {
    if (newState === 1) {
      window.VueApp.$refs.internetConnectionDialog.$refs.root_modal.onClickBtn();
      window.VueApp.$refs.noInternetConnectionDialog.$refs.root_modal.onClickCloseModal();
    } else {
      window.VueApp.$refs.noInternetConnectionDialog.$refs.root_modal.onClickBtn();
      window.VueApp.$refs.internetConnectionDialog.$refs.root_modal.onClickCloseModal();
    }
  }
  internetConnectionStatus = newState;
};

export default function windowInit() {
  // ONLY NECESSARY BLANK METHOD FOR WEB VIEW
  // eslint-disable-next-line no-unused-vars
  window.VueApp.receivePushPermissionStatus = (newState) => {};
  // eslint-disable-next-line no-unused-vars
  window.VueApp.firebaseTokenUpdate = (newToken) => {};
  //
  window.VueApp.pushNotificationReceived = () => {};
  // eslint-disable-next-line no-unused-vars
  window.VueApp.setDeviceData = (manufacturer, model, sdkVersion, platform) => {};
  // eslint-disable-next-line no-unused-vars
  window.VueApp.shareContent = (title, message, url) => {};
  // eslint-disable-next-line no-unused-vars
  window.VueApp.receiveInsetsDimension = (statusBarHeight, navbarHeight) => {
    const closeBtn = window.document.getElementById("connect-app-login-bg__close");
    if (statusBarHeight === 0) {
      return null;
    }

    if (closeBtn) {
      const btnTop = statusBarHeight + 13;
      closeBtn.style.top = btnTop + "px";
    }
  };

  // BASIC SETTINGS
  // Header bg color - useless for ecr25+ app
  if (!window.osAdapter.isEcrApp()) {
    window.osAdapter.setStatusBarColor("#000000", 0);
  }

  // calls window.VueApp.receiveInsetsDimension to set padding-top for html page
  window.osAdapter.getStatusBarHeight();

  // On/offline modal message
  window.VueApp.changeNetworkState = changeNetworkState;
}
